import React from 'react';
import ReactGA from "react-ga4";

const Services = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Features" });
    return (
        <div id="services" className="bg-gray-100 py-12">
            <section data-aos="zoom-in-down">
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">Product Features</h2>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-blue-900'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">Everything you need to understand your vehicle — powered by AI.</h2>
                </div>

                <div className="px-12" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                        {/* Card 1 */}
                        <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-blue-900 hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <div className="flex justify-center mb-4">
                                    <svg className="w-16 h-16 text-blue-700 group-hover:text-blue-300 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
                                    </svg>
                                </div>
                                <h2 className="font-semibold my-4 text-2xl text-center">Bluetooth 4.0</h2>
                                <p className="text-md font-medium">
                                    Seamless wireless pairing with iOS and Android devices. Fast, stable, low-energy connection — no cables, no dongles. Pair once and forget.
                                </p>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-blue-900 hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <div className="flex justify-center mb-4">
                                    <svg className="w-16 h-16 text-blue-700 group-hover:text-blue-300 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18" />
                                    </svg>
                                </div>
                                <h2 className="font-semibold my-4 text-2xl text-center">All 9 OBD2 Protocols</h2>
                                <p className="text-md font-medium">
                                    Full OBDII/EOBD support across all 9 standard protocols. Works with virtually any 12V petrol or diesel vehicle manufactured after 1996 worldwide.
                                </p>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-blue-900 hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <div className="flex justify-center mb-4">
                                    <svg className="w-16 h-16 text-blue-700 group-hover:text-blue-300 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                    </svg>
                                </div>
                                <h2 className="font-semibold my-4 text-2xl text-center">AI Chat Diagnostics</h2>
                                <p className="text-md font-medium">
                                    Ask your AI anything about your car's data — in plain English. Get real explanations for fault codes, sensor readings, and maintenance advice without needing mechanic jargon.
                                </p>
                            </div>
                        </div>

                        {/* Card 4 */}
                        <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-blue-900 hover:text-white rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <div className="flex justify-center mb-4">
                                    <svg className="w-16 h-16 text-blue-700 group-hover:text-blue-300 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                    </svg>
                                </div>
                                <h2 className="font-semibold my-4 text-2xl text-center">Real-Time Diagnostics</h2>
                                <p className="text-md font-medium">
                                    Monitor live engine data, check engine light codes, and vehicle health in real-time. Catch problems early and make smarter decisions about your car.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why it matters section */}
            <section>
                <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="zoom-out">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <div className='text-blue-900 mb-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" className='fill-current'>
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
                                </svg>
                            </div>
                            <h3 className="text-3xl text-blue-900 font-bold">Stop Guessing</h3>
                            <div>
                                <p className='my-3 text-xl text-gray-600 font-semibold'>The check engine light is on — but what does it actually mean for you? AI ScanWiz Pro translates raw OBD2 data into clear, actionable advice so you know exactly what to do next.</p>
                            </div>
                        </div>
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <div className='text-blue-900 mb-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" className='fill-current'>
                                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 14l-4-4 1.41-1.41L11 12.17l6.59-6.59L19 7l-8 8z"/>
                                </svg>
                            </div>
                            <h3 className="text-3xl text-blue-900 font-bold">Stay in Control</h3>
                            <div>
                                <p className='my-3 text-xl text-gray-600 font-semibold'>Know your vehicle's health at all times. AI ScanWiz Pro empowers everyday drivers with the same diagnostic intelligence previously only available to professional mechanics.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services;
